import React from 'react';
import Select from 'react-select';
import AdminUserPicker, { getUserLabel } from './AdminUserPicker';

const customStyles = {
  control: (provided) => ({
    ...provided,
    backgroundColor: 'rgb(81, 84, 82)',
    borderColor: '#444',
    color: '#fff',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'rgb(81, 84, 82)',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'rgba(255, 255, 255, 0.1)'
      : 'rgb(81, 84, 82)',
    color: '#fff',
    cursor: 'pointer',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  input: (provided) => ({
    ...provided,
    color: '#fff',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#ccc',
  }),
};

const AdminReward = () => {
  const [platform, setPlatform] = React.useState('twitch');
  const [selectedUser, setSelectedUser] = React.useState(null);
  const [rewards, setRewards] = React.useState([]);
  const [selectedReward, setSelectedReward] = React.useState('');
  const [quantity, setQuantity] = React.useState(1);
  const [status, setStatus] = React.useState('');
  const [statusType, setStatusType] = React.useState(''); // 'success' | 'error' | ''
  const [loading, setLoading] = React.useState(false);

  // Carga el catálogo de recompensas para el selector (POST porque el handler vive en router.post('/api/adminLogin')).
  React.useEffect(() => {
    const loadRewards = async () => {
      try {
        const res = await fetch('/api/adminLogin?action=getRewardsOption', { method: 'POST' });
        const data = await res.json();
        setRewards(Array.isArray(data) ? data : []);
      } catch (err) {
        setStatus('Error cargando recompensas');
        setStatusType('error');
      }
    };
    loadRewards();
  }, []);

  const handleGive = async () => {
    if (!selectedUser || !selectedUser._id) {
      setStatus('Selecciona un usuario');
      setStatusType('error');
      return;
    }
    if (!selectedReward) {
      setStatus('Selecciona una recompensa');
      setStatusType('error');
      return;
    }
    const qty = parseInt(quantity, 10);
    // Enforce 1..1000 client-side (server enforces the same bound).
    if (isNaN(qty) || qty < 1 || qty > 1000) {
      setStatus('Cantidad inválida (debe ser un entero entre 1 y 1000)');
      setStatusType('error');
      return;
    }
    const label = selectedUser.displayname || selectedUser.youtubeDisplayName || selectedUser._id;
    setLoading(true);
    setStatus('');
    setStatusType('');
    try {
      const formData = new FormData();
      formData.append('userId', selectedUser._id);
      formData.append('rewardId', selectedReward);
      formData.append('quantity', qty);
      const res = await fetch('/api/adminLogin?action=giveReward', {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data && data.success) {
        setStatus('Recompensa añadida correctamente (' + qty + ') a ' + label);
        setStatusType('success');
      } else {
        setStatus('Error: ' + (data && data.error ? data.error : 'desconocido'));
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Error al dar recompensa');
      setStatusType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='heroes formOver'>
      <h1>Dar Recompensa</h1>
      <AdminUserPicker
        platform={platform}
        onPlatformChange={(p) => { setPlatform(p); setSelectedUser(null); }}
        selectedUser={selectedUser}
        onSelectUser={setSelectedUser}
      />
      {loading ? <p>Cargando...</p> : null}
      {selectedUser ? (
        <>
          <div className='formFieldRow'>
            <label className='formFieldLabel heroes'>Recompensa</label>
            <Select
              className='heroes selectForm'
              options={rewards}
              isSearchable
              styles={customStyles}
              placeholder='Buscar recompensa...'
              value={rewards.find(r => r.value === selectedReward) || null}
              onChange={(selectedOption) => setSelectedReward(selectedOption?.value ?? '')}
            />
          </div>
          <div className='formFieldRow'>
            <label className='formFieldLabel heroes'>Cantidad</label>
            <input
              className='userSearch'
              type='number'
              min='1'
              max='1000'
              step='1'
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              onWheel={(e) => e.currentTarget.blur()}
            />
          </div>
          <div className='navTops heroes unselectable'>
            <div onClick={handleGive}>Dar Recompensa a {getUserLabel(selectedUser, platform)}</div>
          </div>
        </>
      ) : null}
      {status ? (
        <p
          role={statusType === 'error' ? 'alert' : 'status'}
          style={{
            padding: '8px 12px',
            borderRadius: 4,
            fontWeight: 600,
            color: statusType === 'success' ? '#0a6b0a' : statusType === 'error' ? '#8a1a1a' : 'inherit',
            backgroundColor: statusType === 'success' ? '#d9f5d9' : statusType === 'error' ? '#fdecea' : 'transparent'
          }}
        >
          {status}
        </p>
      ) : null}
    </div>
  );
};

export default AdminReward;
